import {
  Directive,
  OnInit,
  Optional,
  Inject,
  ViewContainerRef,
  ComponentRef,
  Input,
} from '@angular/core';
import { NgControl } from '@angular/forms';
import { Subscription } from 'rxjs';

import { FORM_ERRORS } from './services/form-errors.factory';
import { RxControlErrorComponent } from './control-error/rx-control-error.component';
import { RxFormControlErrorContainerDirective } from './rx-form-control-error-container.directive';

@Directive({
  selector: '[rxFormControlError]',
})
export class RxFormControlErrorsDirective implements OnInit {
  private subscriptions = new Subscription();
  @Input()
  public customErrors = {};
  public ref: ComponentRef<RxControlErrorComponent>;
  public container: ViewContainerRef;

  constructor(
    @Optional() controlErrorContainer: RxFormControlErrorContainerDirective,
    @Inject(FORM_ERRORS) private _errors,
    private _vcr: ViewContainerRef,
    private _controlDir: NgControl,
  ) {
    this.container = controlErrorContainer ? controlErrorContainer.vcr : _vcr;
  }

  public get control() {
    return this._controlDir.control!;
  }

  public ngOnInit() {
    if (this.control?.valueChanges) {
      this.subscriptions.add(
        this.control.valueChanges.subscribe((v) => {
          this.processErrors(this.control.errors);
        }),
      );
    }

    if (this.control?.statusChanges) {
      this.subscriptions.add(
        this.control.statusChanges.subscribe((status) => {
          this.processErrors(this.control.errors);
        }),
      );
    }
  }

  public processErrors(controlErrors) {
    if (controlErrors) {
      const firstKey = Object.keys(controlErrors)[0];
      const getError = this._errors[firstKey];
      const text = this.customErrors[firstKey] || getError(controlErrors[firstKey]);
      this.setError(text);
    } else if (this.ref) {
      this.setError(null);
    }
  }

  public ngOnDestroy() {
    this.subscriptions.unsubscribe();
  }

  public setError(text: any) {
    if (!this.ref) {
      this.ref = this.container.createComponent(RxControlErrorComponent);
    }

    this.ref.instance.text = text;
  }
}
